module.exports = __webpack_public_path__ + "img/SalesForce.a48fad26.png";